import React from 'react';

// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

// Components
import WpAlert from 'Wpds/components/alert/WpAlert';

// Slugs in this file are primarily used for
// tracking purpose. Please be mindful if a
// change to a slug is needed
const slugPrefix = 'manager-dashboard-intro-modal';

export const CoachingIntrolModalData = {
  slug: slugPrefix,
  slides: [
    {
      slug: 'start-slide',
      title: 'Welcome to your manager dashboard',
      imageBgColor: Colors.purple[25],
      imageWidth: '180px',
      image: Illustrations.manager_dashboard_intro_screenshot,
      nextBtnLabel: 'Got it!',
      footer: (
        <WpAlert type="note">To learn more about each metric, click the information icon next to the name.</WpAlert>
      ),
      description: `Being a good manager means keeping up with your team and knowing where they need the extra help. Keep up with your teams metrics all in one view!`,
    },
  ],
} as NewFeatureCarouselModalType;
